export const getFileExtension = (url) => {
    try {
        return url.split('.').pop()?.toLowerCase() || null;
    } catch {
        return null;
    }
};

export const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff', 'image'];
export const pdfTypes = ['pdf'];
export const videoTypes = ['mp4', 'webm', 'ogg', 'video'];
export const officeTypes = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'odt', 'office'];